
// src/components/EarningsQualityCard.js
import React from 'react';
import { formatNumber } from '../utils/format';
import definitions from '../definitionPlaceholders.json';
import Tooltip from './Tooltip';

const EarningsQualityCard = ({ selectedCompany, stockSymbol, metricsData }) => {
  const defaultMetrics = {
    'Accruals Ratio': 'N/A',
    'CFO / Net Income': 'N/A',
    'Sloan Ratio': 'N/A',
    'DSR Index': 'N/A',
    'Earnings Quality Score': 'N/A',
  };

  const keyMap = {
    'Accruals Ratio': 'accrualsRatio',
    'CFO / Net Income': 'cfoToNetIncome',
    'Sloan Ratio': 'sloanRatio',
    'DSR Index': 'dsrIndex',
    'Earnings Quality Score': 'earningsQualityScore',
  };

  const displayMetrics = {};
  Object.entries(defaultMetrics).forEach(([label, fallback]) => {
    const backendKey = keyMap[label];
    const value = backendKey && metricsData ? metricsData[backendKey] : null;
    displayMetrics[label] = value !== undefined && value !== null ? value : fallback;
  });

  return (
    <div className="w-full my-4">
      <div className="card p-5">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-1 h-6 bg-emerald-500 rounded-full" />
          <h2 className="section-heading">
            Earnings Quality{selectedCompany ? ` | ${selectedCompany}` : ''}{stockSymbol ? ` | ${stockSymbol}` : ''}
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 w-full min-w-0">
          {Object.keys(displayMetrics).map((label, index) => {
            const defKey = keyMap[label];
            const defText = defKey ? definitions[defKey] : null;

            return (
              <div
                key={index}
                className="relative bg-emerald-50 border border-emerald-200 p-4 rounded-lg min-h-[96px] card-hover overflow-x-hidden overflow-y-visible"
              >
                {defText && (
                  <Tooltip content={defText}>
                    <span
                      className="absolute top-2 left-2 text-xs text-gray-500 cursor-help"
                      tabIndex={0}
                      aria-label={`Definition for ${label}`}
                    >
                      ℹ️
                    </span>
                  </Tooltip>
                )}

                <div className="absolute bottom-2 left-2 right-2 text-xs sm:text-sm font-medium text-gray-600 break-words">
                  {label}
                </div>

                <div className="absolute top-5 right-3 left-8 text-sm sm:text-lg font-semibold text-emerald-700 text-right break-words">
                  {formatNumber(label, displayMetrics[label], defKey)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EarningsQualityCard;
